// Dedicated PostHog Logs client. Keep calls here limited to the deliberately
// structured, non-sensitive records added by this integration; it must not
// forward the application's existing console output.
import posthog from "posthog-js";

const posthogConfigured = Boolean(
    import.meta.env.VITE_POSTHOG_PROJECT_TOKEN && import.meta.env.VITE_POSTHOG_HOST
);

function emit(level, message, attributes) {
    if (!posthogConfigured) return;
    posthog.logger[level](message, attributes);
}

export const posthogLogger = {
    info(message, attributes) {
        emit("info", message, attributes);
    },
    error(message, attributes) {
        emit("error", message, attributes);
    }
};
